import { hooks } from "./hookactions"
import { actions } from "./actions"
export let SYSLogin = { hooks, actions }
